var map = {
	"./0.png": 5029,
	"./1.png": 7495,
	"./2.png": 6445,
	"./american-ex.png": 6759,
	"./amex-cc.png": 61,
	"./amex.png": 1731,
	"./credit-card.png": 926,
	"./diners-cc.png": 7794,
	"./diners.png": 4445,
	"./discover-cc.png": 5308,
	"./discover.png": 1753,
	"./jcb-cc.png": 8016,
	"./jcb.png": 5586,
	"./jcb15-cc.png": 6996,
	"./logo-american-express.png": 5174,
	"./logo-mastercard-small.png": 435,
	"./maestro-cc.png": 1105,
	"./mastercard-cc.png": 3647,
	"./mastercard-info.png": 3361,
	"./mastercard-label.png": 8358,
	"./mastercard.png": 2436,
	"./paypal-primary.png": 2785,
	"./paypal.png": 664,
	"./stripe.png": 8661,
	"./uatp-cc.png": 2654,
	"./unionPay-cc.png": 2358,
	"./visa-cc.png": 5918,
	"./visa-dark.png": 3673,
	"./visa-light.png": 2036,
	"./visa.png": 1167,
	"./wallet.png": 5122
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4739;